export default __webpack_public_path__ + "static/media/rusd-gradient.8988a680.svg";